import { scores } from "../config/scoresConfig.js";
import { API_BASE_URL, scoreName } from "../config/config.js";
import { getContract } from "../contracts/getContract.js";
import { IGetScoreParams, IGetScoreResult } from "../types/types.js";

export async function getScoreData({
  address,
  referrerCode,
}: IGetScoreParams): Promise<IGetScoreResult> {
  if (!address) {
    console.error("No address provided");

    return {
      scoreData: null,
      token: null,
      mintData: null,
      isUpdate: false,
      scoreName,
    };
  }

  const scoreConfig = scores[scoreName];
  const { getNonce, getToken } = getContract(address, scoreName);

  const [token, nonce] = await Promise.all([getToken(), getNonce()]);
  const isUpdate = !!token && token.score > 0;

  async function fetchScore() {
    const nonceValue = Number(nonce);

    const deadline = new Date().getTime() + 60 * 60 * 24 * 1000;

    const params: Record<string, string> = {
      scoreType: scoreConfig.scoreType.toString(),
      calculationModel: scoreConfig.calculationModel.toString(),
      nonce: nonceValue.toString(),
      deadline: deadline.toString(),
      UseTokenLists: "false",
      GetCyberConnectProtocolData: "false",
      prepareToMint: "true",
      mintChain: "0",
      referrerCode: referrerCode ?? "",
      TWAReferrer: referrerCode ?? "",
      GetTokensTransfersBalances: "true",
      disableCache: "true",
    };

    if (isUpdate) {
      params.isUpdate = "true";
    }

    let hash;

    const url =
      `${scoreConfig.apiEndpoint}/wallet/${address}/score?` +
      new URLSearchParams(params).toString().replace(/&/g, ":AMP:");

    try {
      const response = await fetch(
        `${API_BASE_URL}/score?type=${scoreConfig.type}&address=${address}&message=nomisscore&hash=${hash}&url=${url}`
      );

      const responseData = await response.json();

      if (responseData.error) {
        return responseData.error;
      }

      return responseData;
    } catch (error) {
      return error;
    }
  }

  const scoreData = await fetchScore();
  const mintData = {
    ...scoreData?.mintData,
    mintPrice: scoreData?.mintPrice,
    referrerReward: scoreData?.referrerReward,
    referrerAddress: scoreData?.referrerAddress,
  };

  return {
    scoreData,
    mintData,
    token,
    isUpdate,
    scoreName,
  };
}
